import Heading from 'components/Basic/Heading/Heading';
import ProductsSlider from 'components/Blocks/Product/ProductsSlider';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { SliderProductItemType } from 'types/product';

type ProductDetailSparePartsProps = {
    spareParts: SliderProductItemType[];
};

const ProductDetailSpareParts: FC<ProductDetailSparePartsProps> = ({ spareParts }) => {
    const t = useTypedTranslationFunction();

    if (spareParts.length === 0) {
        return null;
    }

    return (
        <>
            <Heading type="h2" className="hidden vl:block">
                {t('Spare parts')} ({spareParts.length})
            </Heading>
            <ProductsSlider products={spareParts} gtmListName="detail spare parts" idSuffix="-spare-parts" />
        </>
    );
};

export default ProductDetailSpareParts;
